
import { put, takeEvery } from 'redux-saga/effects';
import { actionType } from "../../store/connectint/action";
import data from "../../assets/lang/jp/connectint-page";
import api from '../../services/API';

/**
 * @method get the page data like header, title etc 
 * @params: none
 * @output: object data
 */
function* fetchPageData() {
  yield put({ type: actionType.GET_QA_PAGE_DATA_RECEIVED, payload: data });
}



/**
 * @method to call the QA listing page 
 * @params: primary Question
 * @output: object data
 */
function* getQuestionList(param) {
  try {   
    

    let  questionList = yield api.connectint.getQuestionList(param.payload);
    //questionList.data = param.payload === 'primary' ? questionList.data : questionList[param.payload].data;
  
    /* if(questionList.data ===''){
      questionList.data = {
          statusCode: 500,
          question : {}        
      }
    } */
    
    yield put({
      type: actionType.QUESTION_LIST_SUCCESS,
      //payload: param.payload === 'primary' ? questionList.data : questionList[param.payload].data      
      payload: questionList.data 
    })
  } catch (exception) {
   
    yield put({
      type: actionType.QUESTION_LIST_FAILURE,
      payload: exception.response
    })
  }

}

/**
 * 
 */
export const ConnectintSagas = [
  takeEvery(actionType.GET_QA_PAGE_DATA_REQUEST, fetchPageData),
  takeEvery(actionType.QUESTION_LIST_REQUEST, getQuestionList)
]